export const MarketsIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='1.5' y='5.5' width='12' height='8' />
        <rect x='5.5' y='1.5' width='4' height='4' />
    </svg>
);

export const CalendarIcon = (props: { filled?: boolean } = {}) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='1.5' y='3.5' width='12' height='10' fill={props.filled ? 'currentColor' : 'none'} />
        <path d='M1.5 6.5 L13.5 6.5' stroke={props.filled ? 'var(--color-background)' : 'currentColor'} />
        <path d='M4.5 1.5 L4.5 4.5' stroke-linecap='square' />
        <path d='M10.5 1.5 L10.5 4.5' stroke-linecap='square' />
        {props.filled && (
            <>
                <path d='M4.5 9.5 L10.5 9.5' stroke='var(--color-background)' stroke-linecap='square' />
                <path d='M4.5 11.5 L8.5 11.5' stroke='var(--color-background)' stroke-linecap='square' />
            </>
        )}
    </svg>
);

export const ScreenerIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='1.5' y='1.5' width='12' height='12' />
        <path d='M1.5 5.5 L13.5 5.5' />
        <path d='M1.5 9.5 L13.5 9.5' />
    </svg>
);

export const DeepDivesIcon = (props: { filled?: boolean } = {}) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1'>
        <circle cx='7.5' cy='7.5' r='6' fill={props.filled ? 'currentColor' : 'none'} />
        <circle cx='7.5' cy='7.5' r='3' stroke={props.filled ? 'var(--color-background)' : 'currentColor'} />
    </svg>
);

export const TradesIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1'>
        <circle cx='7.5' cy='7.5' r='6' />
        <rect x='6.5' y='6.5' width='2' height='2' fill='currentColor' stroke='none' />
    </svg>
);

// Other — same circle as Trades/Deep Dives, with an "x" spanning the full circle
// (endpoints on the circle edge) — watched but not taken: skipped/missed/passed.
export const OtherIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1'>
        <circle cx='7.5' cy='7.5' r='6' />
        <line x1='3.26' y1='3.26' x2='11.74' y2='11.74' />
        <line x1='11.74' y1='3.26' x2='3.26' y2='11.74' />
    </svg>
);

export const WatchlistIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='1.5' y='1.5' width='12' height='12' />
        <path d='M1.5 9.5 L13.5 9.5' />
        <path d='M3.5 3.5 L11.5 3.5' stroke-linecap='square' />
        <path d='M3.5 5.5 L11.5 5.5' stroke-linecap='square' />
        <path d='M3.5 7.5 L11.5 7.5' stroke-linecap='square' />
    </svg>
);

export const RefreshIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linejoin='round'>
        {/* Crescent ring (r5.5) with an even gap centered at the top */}
        <path d='M5.5 3.5 A5.5 5.5 0 1 0 10.5 3.5' />
        {/* L-shaped arrowhead; 6px top + 5px down, crisp. The arc end (10.5,3.5) sits on the horizontal leg */}
        <path d='M15.5 3.5 L9.5 3.5 L9.5 8.5' stroke-linejoin='miter' shape-rendering='crispEdges' />
    </svg>
);

// Single centered candlestick — "inspect bar".
export const InspectBarIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {/* End lines */}
        <path d='M1.5 1.5 L1.5 13.5' />
        <path d='M13.5 1.5 L13.5 13.5' />
        {/* Candle — wick on x=7.5 (.5 grid, crisp), body symmetric around it */}
        <path d='M7.5 1.5 L7.5 3.5' />
        <path d='M7.5 10.5 L7.5 13.5' />
        <rect x='5.5' y='3.5' width='4' height='7' />
    </svg>
);

export const TextToolIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <path d='M2 1.5 L13 1.5' />
        <path d='M7.5 1.5 L7.5 13.5' />
    </svg>
);

// Visibility toggle — empty square when hidden; filled inner square when visible.
export const VisibleSquareIcon = (props: { visible: boolean }) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' shape-rendering='crispEdges'>
        <rect x='1.5' y='1.5' width='12' height='12' />
        {props.visible && <rect x='4' y='4' width='7' height='7' fill='currentColor' stroke='none' />}
    </svg>
);

// Bookmark (pin) — classic ribbon, V-notch bottom; fills when pinned.
export const BookmarkIcon = (props: { filled: boolean }) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill={props.filled ? 'currentColor' : 'none'} stroke='currentColor' stroke-width='1' stroke-linejoin='miter'>
        <path d='M4.5 1.5 L11.5 1.5 L11.5 13.5 L8 10.5 L4.5 13.5 Z' />
    </svg>
);

// Edit (pencil).
export const EditIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linejoin='miter' shape-rendering='geometricPrecision'>
        <path d='M11.5 1.5 L13.5 3.5 L3.5 13.5 L1.5 13.5 L1.5 11.5 Z' />
        <path d='M9.5 3.5 L11.5 5.5' />
    </svg>
);

export const RoutineIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2.5' y='1.5' width='10' height='12' />
        <rect x='4' y='3' width='2' height='2' fill='currentColor' stroke='none' />
        <rect x='4' y='6' width='2' height='2' fill='currentColor' stroke='none' />
        <rect x='4' y='9' width='2' height='2' fill='currentColor' stroke='none' />
    </svg>
);

export const FullscreenIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <path d='M2.5 5.5 L2.5 2.5 L5.5 2.5' stroke-linecap='square' />
        <path d='M13.5 5.5 L13.5 2.5 L10.5 2.5' stroke-linecap='square' />
        <path d='M2.5 10.5 L2.5 13.5 L5.5 13.5' stroke-linecap='square' />
        <path d='M13.5 10.5 L13.5 13.5 L10.5 13.5' stroke-linecap='square' />
    </svg>
);

export const FullscreenExitIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <path d='M5.5 2.5 L5.5 5.5 L2.5 5.5' stroke-linecap='square' />
        <path d='M10.5 2.5 L10.5 5.5 L13.5 5.5' stroke-linecap='square' />
        <path d='M5.5 13.5 L5.5 10.5 L2.5 10.5' stroke-linecap='square' />
        <path d='M10.5 13.5 L10.5 10.5 L13.5 10.5' stroke-linecap='square' />
    </svg>
);

// Code brackets </> — marks the isolated dev sandbox activity.
export const DevIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
        <path d='M5.5 4 L2 8 L5.5 12' />
        <path d='M10.5 4 L14 8 L10.5 12' />
    </svg>
);

export const NotesIcon = (props: { filled?: boolean } = {}) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2.5' y='1.5' width='10' height='12' fill={props.filled ? 'currentColor' : 'none'} />
        <path d='M4.5 4.5 L10.5 4.5' stroke-linecap='square' stroke={props.filled ? 'var(--color-background)' : 'currentColor'} />
        <path d='M4.5 7.5 L10.5 7.5' stroke-linecap='square' stroke={props.filled ? 'var(--color-background)' : 'currentColor'} />
        <path d='M4.5 10.5 L8.5 10.5' stroke-linecap='square' stroke={props.filled ? 'var(--color-background)' : 'currentColor'} />
    </svg>
);

export const PlanIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2.5' y='1.5' width='10' height='12' />
        <rect x='4.5' y='3.5' width='6' height='8' />
    </svg>
);

export const CalendarRangeIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='1.5' y='3.5' width='12' height='10' />
        <path d='M1.5 6.5 L13.5 6.5' />
        <path d='M4.5 1.5 L4.5 4.5' stroke-linecap='square' />
        <path d='M10.5 1.5 L10.5 4.5' stroke-linecap='square' />
        {/* Range bar — outline rect with a 1px-high hollow center */}
        <rect x='3.5' y='8.5' width='8' height='2' />
    </svg>
);

// Ban / not-allowed — circle with a diagonal slash.
export const BanIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1'>
        <circle cx='8' cy='8' r='5.5' />
        <path d='M4.5 11.5 L11.5 4.5' />
    </svg>
);

// Indicators — stepped signal line over a connected histogram.
export const IndicatorsIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1'>
        {/* Signal line — 2px steps land on bar centers (x=3.5 up, 7.5 down, 11.5 up) */}
        <path d='M1.5 3.5 L3.5 3.5 L3.5 1.5 L7.5 1.5 L7.5 3.5 L11.5 3.5 L11.5 1.5 L13.5 1.5' stroke-linejoin='miter' stroke-linecap='square' shape-rendering='crispEdges' />
        {/* Histogram — connected 1px outline bars sharing vertical edges */}
        <rect x='1.5' y='8.5' width='4' height='5' shape-rendering='crispEdges' />
        <rect x='5.5' y='6.5' width='4' height='7' shape-rendering='crispEdges' />
        <rect x='9.5' y='7.5' width='4' height='6' shape-rendering='crispEdges' />
    </svg>
);

export const ReplayIcon = (props: { filled?: boolean } = {}) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linejoin='miter' shape-rendering='geometricPrecision'>
        <path d='M7.5 2.5 L7.5 13.5 L2.5 8 Z' fill={props.filled ? 'currentColor' : 'none'} />
        <path d='M13.5 2.5 L13.5 13.5 L8.5 8 Z' fill={props.filled ? 'currentColor' : 'none'} />
    </svg>
);

export const CrossHairToolIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <path d='M7.5 1.5 L7.5 6.5' />
        <path d='M7.5 9.5 L7.5 14.5' />
        <path d='M1.5 7.5 L6.5 7.5' />
        <path d='M9.5 7.5 L14.5 7.5' />
    </svg>
);

export const MeasureToolIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='1.5' y='5.5' width='13' height='5' />
        <path d='M4.5 5.5 L4.5 7.5' />
        <path d='M7.5 5.5 L7.5 8.5' />
        <path d='M10.5 5.5 L10.5 7.5' />
    </svg>
);

export const TrashIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <path d='M1.5 3.5 L14.5 3.5' />
        <path d='M5.5 3.5 L5.5 1.5 L10.5 1.5 L10.5 3.5' />
        <rect x='3.5' y='3.5' width='9' height='10' />
    </svg>
);

export const PortfoliosIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2.5' y='4.5' width='11' height='9' />
        <path d='M2.5 7.5 L13.5 7.5' stroke-linecap='square' />
        <path d='M5.5 4.5 L5.5 2.5 L10.5 2.5 L10.5 4.5' stroke-linecap='square' />
    </svg>
);

export const CandlestickIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <path d='M4.5 1.5 L4.5 3.5' />
        <path d='M4.5 10.5 L4.5 13.5' />
        <rect x='2.5' y='3.5' width='4' height='7' />
        <path d='M10.5 3.5 L10.5 5.5' />
        <path d='M10.5 9.5 L10.5 12.5' />
        <rect x='8.5' y='5.5' width='4' height='4' />
    </svg>
);

// Single full-height candle on the left, a baseline at the bottom-right.
export const FirstBarIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {/* Candle on the left — 7px body (3.5 → 10.5) */}
        <path d='M4.5 1.5 L4.5 3.5' />
        <path d='M4.5 10.5 L4.5 13.5' />
        <rect x='2.5' y='3.5' width='4' height='7' />
        {/* Line at the bottom right */}
        <path d='M8.5 12.5 L13.5 12.5' />
    </svg>
);

// Mirror of FirstBarIcon — candle on the right, baseline at the bottom-left.
export const LastBarIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {/* Candle on the right — 7px body (3.5 → 10.5) */}
        <path d='M11.5 1.5 L11.5 3.5' />
        <path d='M11.5 10.5 L11.5 13.5' />
        <rect x='9.5' y='3.5' width='4' height='7' />
        {/* Line at the bottom left */}
        <path d='M2.5 12.5 L7.5 12.5' />
    </svg>
);

// Like FirstBarIcon (candle on the left) but with a minus on the right — "step back one bar".
export const PrevBarIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {/* Candle on the left — 7px body (3.5 → 10.5) */}
        <path d='M4.5 1.5 L4.5 3.5' />
        <path d='M4.5 10.5 L4.5 13.5' />
        <rect x='2.5' y='3.5' width='4' height='7' />
        {/* Minus on the right */}
        <path d='M9 7.5 L14 7.5' />
    </svg>
);

// Mirror of PrevBarIcon — candle on the right, plus on the left — "step forward one bar".
export const NextBarIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {/* Candle on the right — 7px body (3.5 → 10.5) */}
        <path d='M11.5 1.5 L11.5 3.5' />
        <path d='M11.5 10.5 L11.5 13.5' />
        <rect x='9.5' y='3.5' width='4' height='7' />
        {/* Plus on the left */}
        <path d='M2 7.5 L7 7.5' />
        <path d='M4.5 5 L4.5 10' />
    </svg>
);

// Archive box — 12px lid over a 10px body, centered on x=7.5.
// `filled` toggles the archived state: the box fills solid, with the handle dash
// and lid seam knocked out in the background color.
export const ArchiveIcon = (props: { filled?: boolean }) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='1.5' y='2.5' width='12' height='3' fill={props.filled ? 'currentColor' : 'none'} />
        <path d='M2.5 5.5v8h10v-8' fill={props.filled ? 'currentColor' : 'none'} />
        {props.filled ? (
            <>
                <path d='M3.5 5.5 L12.5 5.5' stroke='var(--color-background)' />
                <path d='M6 8.5h3' stroke='var(--color-background)' />
            </>
        ) : (
            <path d='M6 8.5h3' />
        )}
    </svg>
);

// Chevron arrows — true 45°, centered on (8,8), 1px round joins.
export const ArrowUpIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
        <path d='M3 10.5 L8 5.5 L13 10.5' />
    </svg>
);

export const ArrowDownIcon = (props: { open?: boolean | (() => boolean); class?: string }) => {
    const isOpen = () => (typeof props.open === 'function' ? props.open() : props.open);
    return (
        <svg class={`w-4 h-4 transition-transform duration-200 ${isOpen() ? 'rotate-180' : ''} ${props.class ?? ''}`} viewBox='0 0 16 16' fill='none' stroke='currentColor' opacity='0.5' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
            <path d='M3 5.5 L8 10.5 L13 5.5' />
        </svg>
    );
};

export const ArrowLeftIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
        <path d='M10.5 3 L5.5 8 L10.5 13' />
    </svg>
);

export const ArrowRightIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
        <path d='M5.5 3 L10.5 8 L5.5 13' />
    </svg>
);

// Go-to — diagonal arrow whose head is a right-angle corner at the TOP-RIGHT of
// the box (the two barbs trace the top and right edges meeting at the corner),
// with the shaft running up into it from the lower-left. Reads as "open / jump
// to".
export const GoToIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
        <path d='M2.5 13.5 L13.5 2.5' />
        <path d='M5.5 2.5 L13.5 2.5 L13.5 10.5' />
    </svg>
);

export const DoubleArrowLeftIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
        <path d='M8 3 L3 8 L8 13' />
        <path d='M13 3 L8 8 L13 13' />
    </svg>
);

export const DoubleArrowRightIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
        <path d='M3 3 L8 8 L3 13' />
        <path d='M8 3 L13 8 L8 13' />
    </svg>
);

// Down arrow dropping onto a baseline — "import".
export const ImportIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {/* Base line */}
        <path d='M3.5 12.5 L12.5 12.5' />
        {/* Arrow dropping in */}
        <path d='M8 2 L8 10.5' />
        <path d='M5.5 8 L8 10.5 L10.5 8' stroke-linecap='round' stroke-linejoin='round' />
    </svg>
);

export const UserIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {/* Head */}
        <rect x='5.5' y='2.5' width='5' height='5' />
        {/* Body — open bottom, 1px gap below head */}
        <path d='M3.5 13.5 L3.5 9.5 L12.5 9.5 L12.5 13.5' stroke-linejoin='miter' />
    </svg>
);

export const LayoutIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2.5' y='2.5' width='11' height='11' stroke-linejoin='miter' />
    </svg>
);

export const LineToolIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1'>
        <path d='M2.5 13.5 L13.5 2.5' />
    </svg>
);

export const HorizontalLineToolIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <path d='M2 8 L14 8' />
    </svg>
);

export const SplitHorizontalIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2' y='2' width='5' height='12' />
        <rect x='9' y='2' width='5' height='12' />
    </svg>
);

export const SplitVerticalIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2' y='2' width='12' height='5' />
        <rect x='2' y='9' width='12' height='5' />
    </svg>
);

export const PauseIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='4' y='2' width='3' height='12' />
        <rect x='9' y='2' width='3' height='12' />
    </svg>
);

export const SettingsIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {/* Top — full width */}
        <path d='M2 4 L14 4' />
        {/* Middle — half width */}
        <path d='M2 8 L8 8' />
    </svg>
);

export const SearchIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
        <circle cx='7.5' cy='7.5' r='5' />
        <path d='M11 11 L14 14' />
    </svg>
);

export const PlusIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <path d='M8 1.5v13M1.5 8h13' />
    </svg>
);

export const PlayIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linejoin='miter' shape-rendering='geometricPrecision'>
        <path d='M4.5 2.5 L4.5 13.5 L14 8 Z' />
    </svg>
);

// ReportIcon: a paper sheet outline with a bar chart inside; fills solid with
// the bars knocked out in the background color (same toggle pattern as NotesIcon).
export const ReportIcon = (props: { filled?: boolean } = {}) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2.5' y='1.5' width='10' height='12' fill={props.filled ? 'currentColor' : 'none'} />
        <path d='M4.5 8.5 L4.5 12.5' stroke={props.filled ? 'var(--color-background)' : 'currentColor'} />
        <path d='M7.5 6.5 L7.5 12.5' stroke={props.filled ? 'var(--color-background)' : 'currentColor'} />
        <path d='M10.5 4.5 L10.5 12.5' stroke={props.filled ? 'var(--color-background)' : 'currentColor'} />
    </svg>
);

// Sun — stroked center disc with 8 rays (pre-open earnings marker).
export const SunIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round'>
        {/* Center disc */}
        <circle cx='7.5' cy='7.5' r='3' />
        {/* Cardinal rays */}
        <path d='M7.5 1.5 L7.5 3' />
        <path d='M7.5 12 L7.5 13.5' />
        <path d='M1.5 7.5 L3 7.5' />
        <path d='M12 7.5 L13.5 7.5' />
        {/* Diagonal rays */}
        <path d='M3.4 3.4 L4.5 4.5' />
        <path d='M10.5 4.5 L11.6 3.4' />
        <path d='M10.5 10.5 L11.6 11.6' />
        <path d='M3.4 11.6 L4.5 10.5' />
    </svg>
);

// ColumnsIcon: three vertical columns on the .5 grid, 2px gaps so the
// strokes don't merge into a doubled band.
export const ColumnsIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2.5' y='2.5' width='2' height='11' />
        <rect x='6.5' y='2.5' width='2' height='11' />
        <rect x='10.5' y='2.5' width='2' height='11' />
    </svg>
);

// RowsIcon: three horizontal rows — ColumnsIcon rotated 90°, 2px gaps.
export const RowsIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <rect x='2.5' y='2.5' width='11' height='2' />
        <rect x='2.5' y='6.5' width='11' height='2' />
        <rect x='2.5' y='10.5' width='11' height='2' />
    </svg>
);

// Heatmap — a 3x3 grid (single shared gridlines, drawn over the fills so they
// stay crisp). Toggling on fills a bottom-left triangular ramp of cells solid,
// evoking graded intensity (off = plain outlined grid).
export const HeatmapIcon = (props: { filled?: boolean } = {}) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {props.filled && (
            <g fill='currentColor' stroke='none'>
                <rect x='1.5' y='1.5' width='4' height='4' />
                <rect x='1.5' y='5.5' width='4' height='4' />
                <rect x='5.5' y='5.5' width='4' height='4' />
                <rect x='1.5' y='9.5' width='4' height='4' />
                <rect x='5.5' y='9.5' width='4' height='4' />
                <rect x='9.5' y='9.5' width='4' height='4' />
            </g>
        )}
        <rect x='1.5' y='1.5' width='12' height='12' />
        <path d='M5.5 1.5 L5.5 13.5' />
        <path d='M9.5 1.5 L9.5 13.5' />
        <path d='M1.5 5.5 L13.5 5.5' />
        <path d='M1.5 9.5 L13.5 9.5' />
    </svg>
);

// Week totals — a 2-column x 3-row day grid plus a full-height summary column on
// the right that fills solid when toggled on. Gridlines are single shared
// strokes drawn over the fill so they render crisp.
export const WeekTotalsIcon = (props: { filled?: boolean } = {}) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        {props.filled && <rect x='9.5' y='1.5' width='4' height='12' fill='currentColor' stroke='none' />}
        <rect x='1.5' y='1.5' width='12' height='12' />
        <path d='M5.5 1.5 L5.5 13.5' />
        <path d='M9.5 1.5 L9.5 13.5' />
        <path d='M1.5 5.5 L9.5 5.5' />
        <path d='M1.5 9.5 L9.5 9.5' />
    </svg>
);

// Check / tick — 1px stroked checkmark.
export const CheckIcon = () => (
    <svg class='w-4 h-4 shrink-0' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'>
        <path d='M3.5 8.5 L6.5 11.5 L12.5 4.5' />
    </svg>
);

// Cross / close — full-box diagonal X (2.5 → 13.5).
export const CrossIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1'>
        <path d='M2.5 2.5 L13.5 13.5' />
        <path d='M13.5 2.5 L2.5 13.5' />
    </svg>
);

// Moon — fat stroked crescent (after-hours / overnight marker).
export const MoonIcon = () => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' stroke-linejoin='round'>
        {/* Crescent: large outer rim, offset inner bite — kept fat so the
            two edges read as one open crescent, not a doubled line */}
        <path d='M7.1 2.6 A5.5 5.5 0 1 0 13.4 8.9 A4.5 4.5 0 0 1 7.1 2.6 Z' />
    </svg>
);

export const AlertIcon = (props: { filled?: boolean } = {}) => (
    <svg class='w-4 h-4' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1' style={{ 'shape-rendering': 'crispEdges' }}>
        <path d='M6.5 2.5 L9.5 2.5 L10.5 3.5 L10.5 8.5 L12.5 10.5 L12.5 11.5 L3.5 11.5 L3.5 10.5 L5.5 8.5 L5.5 3.5 Z' fill={props.filled ? 'currentColor' : 'none'} />
        <path d='M6.5 13.5 L9.5 13.5' />
    </svg>
);
